import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import PropTypes from 'prop-types';
// Models
import mCarpark from 'models/cpm/carpark';
// Permissions
import permissions from 'constants/Permissions';
// HOCs
import withPermissions from 'hocs/WithPermissions';
import withLoading from 'hocs/WithLoading';
import withTitle from 'hocs/WithTitle';
import withStateReinit from 'hocs/WithStateReinit';
// Hooks
import useResponsive from 'hooks/useResponsive';
// Custom
import { cpmGetCarparksList } from 'actions';
import { fullListShape } from 'constants/PropTypesShapes';
import MainListTemplate from 'components/templates/MainListTemplate';
import LoadingDisplayer from 'components/misc/LoadingDisplayer';
import { navigateToBook } from 'cpmBook/navigation';
import CarparkRow from 'cpmBook/assets/CarparkRow';
import CarparkFilters from 'cpmCarparks/assets/main/CarparkFilters';

const CarparksList = ({
  carparks,
  hasPermission,
  handleStartLoading,
  dispatchGetCarparksList,
}) => {
  const [initialLoading, setInitialLoading] = React.useState(true);

  const {
    pBooking: { bookings },
  } = permissions;

  React.useEffect(function getParkarsAvailableForBooking() {
    dispatchGetCarparksList({ page: 1, pageSize: 20 }, [], [], true);
  }, []);
  /* ✅ ⬇️ */
  React.useEffect(
    function redirectToBookingPageIfThereIsOnlyOneCarparkAvailable() {
      if (!carparks.loading && carparks.elements.data) {
        const thereIsOnlyOneCarparkAvailable = carparks.elements.totalEntries === 1 && carparks.elements.data.length === 1;
        if (thereIsOnlyOneCarparkAvailable) {
          const uniqueCarpark = carparks.elements.data[0];
          const canAccessThisCarpark = hasPermission({
            needed: bookings,
            permissionsOrContext: uniqueCarpark.permissions,
          });
          handleStartLoading();
          if (canAccessThisCarpark) setTimeout(() => navigateToBook(uniqueCarpark.id), 100);
        } else {
          setInitialLoading(false);
        }
      }
    },
    [carparks],
  );

  const doGetRowComp = (props) => <CarparkRow {...props} />;

  const isMobile = useResponsive();

  const PageTitle = (
    <div className={`d-flex justify-content-${isMobile ? 'center text-center' : 'end'} bookPageTitle`}>
      <LocalizedMessage id="title.availableCarparks" />
    </div>
  );

  return (
    <LoadingDisplayer loading={initialLoading}>
      <div className="d-flex flex-column mx-auto">
        {PageTitle}
        <MainListTemplate
          title=""
          withDivider={false}
          name={mCarpark.name}
          listFeatures={mCarpark.listFeaturesBookModule}
          elementsData={{
            loading: carparks.loading,
            elements: carparks.elements,
            handleGetList: dispatchGetCarparksList,
          }}
          rowComp={doGetRowComp}
          withPadding={false}
          filtersComp={<CarparkFilters />}
        />
      </div>
    </LoadingDisplayer>
  );
};

CarparksList.propTypes = {
  carparks: fullListShape.isRequired,
  hasPermission: PropTypes.func.isRequired, // eslint-disable-line react/no-unused-prop-types
  dispatchGetCarparksList: PropTypes.func.isRequired,
  handleStartLoading: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  carparks: state.cpmCarpark.list,
  mePermissions: state.me.permissions,
  slugId: state.cpmSlug.current.result.id,
});

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { dispatch } = dispatchProps;

  return {
    ...ownProps,
    ...stateProps,
    dispatchGetCarparksList: (pagination, sort, filters, count = false) => {
      dispatch(
        cpmGetCarparksList(
          mCarpark.queListCarparks,
          { slugId: stateProps.slugId },
          { pagination, sort, filters },
          count,
        ),
      );
    },
  };
};

module.exports = compose(
  withPermissions,
  withLoading,
  withStateReinit(['listCarparks']),
  withTitle('pageTitle.availableCarparks'),
  connect(mapStateToProps, null, mergeProps),
)(CarparksList);



// WEBPACK FOOTER //
// ./routes/book/routes/carparks/components/CarparksList.js